import React from 'react';
import ThemeSelector from '../../components/ThemeSelector';
import { useTheme } from '../../contexts/ThemeContext';

const AdminSettingsPage: React.FC = () => {
  const { colors } = useTheme();

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2" style={{ color: colors.text.primary }}>
          Admin Settings
        </h1>
        <p className="text-lg" style={{ color: colors.text.secondary }}>
          Customize your admin dashboard experience
        </p>
      </div>

      <div className="grid gap-8">
        <div
          className="p-6 rounded-xl"
          style={{
            backgroundColor: colors.background.paper,
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          }}
        >
          <ThemeSelector />
        </div>

        {/* Add more settings sections here */}
      </div>
    </div>
  );
};

export default AdminSettingsPage; 